import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import { observer } from 'mobx-react';
import Loading from '../../App/Components/Loading/Loading';
import { TextConstants } from '../../Common/TextConstants';
import ManageOrganisationMappingComponent from './components/ManageOrganisationComponentView';
import OrganisationVM from './OrganisationVM';

@observer
export default class OrganisationView extends Views.ViewBase<OrganisationVM> {

    constructor(props: unknown) {
        super("Organisation", OrganisationVM, props);
    }
  
    public render() {
        return (
            <div>
            {(this.viewModel.taskRunner.isBusy) && <Loading />}
            {this.viewModel.showManageOrganisationComponent &&
            <ManageOrganisationMappingComponent
                viewModel={this.viewModel.manageOrganisationComponentVM}
                onSave={() => this.viewModel.saveOrganisation()}
                onCancel={() => this.viewModel.cancelOrganisation()} />
                        }
            {!this.viewModel.showManageOrganisationComponent &&
                <Neo.Card title={TextConstants.Titles.Organisations} className="m-1">
                        <div className="row pb-3">
                            <div className="col text-right">
                                <Neo.Button
                                    onClick={() => this.viewModel.addOrganisation()}
                                    variant="primary" size="sm"
                                >{TextConstants.Buttons.AddOrganisation}</Neo.Button>
                            </div>
                        </div>
                    <div>
                    <NeoGrid.Grid className={"table-striped"} items = 
                    {this.viewModel.OrganisationList}>
                            {(item, meta) => (
                                <NeoGrid.Row key={item.organisationName}>
                                    <NeoGrid.Column display={meta.organisationName} />
                                    <NeoGrid.ButtonColumn label={TextConstants.Labels.Edit} className="text-center">
                                            <Neo.Button
                                                onClick={() => this.viewModel.editOrganisation(item)}
                                                variant="primary" isOutline className="btn-small"
                                            ><i className="fa fa-edit"></i></Neo.Button>
                                        </NeoGrid.ButtonColumn>                        
                                </NeoGrid.Row>
                            )}
                        </NeoGrid.Grid>
                    </div>
                </Neo.Card>
            }
        </div>
    )};
}
